import { useQuery } from '@office-start/data-fetching';
import { executeEncryptionKeyDataFlow } from '../executeEncryptionKeyDataFlow';
import { useIdentity } from './useIdentity';
export function useEncryptionKey() {
    var identity = useIdentity().data;
    var query = ['EncryptionKey', identity === null || identity === void 0 ? void 0 : identity.puid];
    return useQuery(query, function () {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return executeEncryptionKeyDataFlow(identity);
    }, {
        cacheTime: Infinity,
        staleTime: Infinity,
        enabled: !!identity,
    });
}
//# sourceMappingURL=useEncryptionKey.js.map